import { render, staticRenderFns } from "./RelatedCustomerStories.vue?vue&type=template&id=cd7e0a96"
import script from "./RelatedCustomerStories.vue?vue&type=script&lang=js"
export * from "./RelatedCustomerStories.vue?vue&type=script&lang=js"
import style0 from "./RelatedCustomerStories.vue?vue&type=style&index=0&id=cd7e0a96&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports